import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from "react-router-dom";
import { fetchData } from "../../utils/functions";
import {
  ThinDropdown,
  ThinTextField,
  NICInputField,
  PhoneInputField,
  BackButton,
  ThinDropdownWithSearch,
} from "../common/GeneralComponent";
import Loader from "./Loader";

const GetProfile = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);

  const userSession = useSelector((state) => state?.auth);

  const [user, setUser] = useState({
    name: "",
    email: "",
    cnic: "",
    phone_number: "",
    status: "",
    group_name: "",
    role_name: "",
  });

  const fetchUser = async () => {
    try {
      const response = await fetchData(
        "user-profile",
        "GET",
        null,
        {},
        { id: userSession.user.id },
        navigate,
        "/user",
        dispatch,
      );

      const userData = response?.data?.[0];
      if (userData) {
        setUser({
          name: userData.name || "",
          email: userData.email || "",
          cnic: userData.cnic || "",
          phone_number: userData.phone_number || "",
          status: userData.status || "",
          group_name: userData.group?.name || "",
          role_name: userData.role_name || "",
        });
      }
    } catch (error) {
      console.error("Error fetching user:", error);
      toast.error("Failed to fetch user data");
    } finally {
      setLoader(false);
    }
  };


  useEffect(() => {
    fetchUser();
  }, [id]);

  return (
    <div className="w-full my-4 mx-auto">
      {loader && <Loader />}
      <div className="flex lg:flex-row flex-col lg:justify-between justify-start lg:items-center items-start gap-3 w-full">
        <h1 className="lg:text-[1.475rem] text-[1rem] text-[#212529] font-[Bold]">
          Profile
        </h1>
        <BackButton to="/" text="Back" />
      </div>

      <div className="bg-white rounded-lg shadow w-full lg:mb-[30px] mt-4 mb-[7rem]">
        <div className="p-4 flex md:flex-row rounded-t-lg gradiant2 flex-col gap-3 justify-between md:items-center border-lightGray border-b ">
          <h1 className="text-[0.875rem] tracking-[0.0625rem] text-[#856800] font-[bold] uppercase">
            Profile
          </h1>
        </div>

        <div className="p-4 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="col-span-1 mt-3">
            <ThinTextField
              label="Group"
              value={user.group_name}
              readOnly
              isRequired={false}
            />
          </div>

          <div className="col-span-1 mt-3">
            <ThinTextField
              label="Role"
              value={user.role_name}
              readOnly
              isRequired={false}
            />
          </div>

          <div className="col-span-1 mt-3">
            <ThinTextField
              label="Status"
              value={Number(user.status) === 1 ? "Active" : "Inactive"}
              readOnly
              isRequired={false}
            />
          </div>

          <div className="col-span-1 mt-3">
            <ThinTextField
              id="name"
              label="Name"
              value={user.name}
              disabled
              isRequired={false}
            />
          </div>

          <div className="col-span-1 mt-3">
            <ThinTextField
              id="email"
              isRequired={false}
              label="Email"
              value={user.email}
              disabled
            />
          </div>

          <div className="col-span-1">
            <NICInputField
              value={user.cnic}
              label="CNIC"
              readOnly
              placeholder="N/A"
            />
          </div>

          <div className="col-span-1">
            <PhoneInputField
              value={user.phone_number}
              label="Phone Number"
              isRequired={false}
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetProfile;
